import { ReactNode } from 'react';

import { Div } from '@consumer-frontend/shared-ui';

export type NcCardHeadingPropsT = {
  children: ReactNode;
  level: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
};

export const NcCardHeading: React.FC<NcCardHeadingPropsT> = ({
  children,
  level,
  className,
}) => {
  return (
    <Div as={`h${level}`} className={className}>
      {children}
    </Div>
  );
};
